import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import ReimburseComponent from "../ReimburseComponent/ReimburseComponent";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";

const MyReimbursements = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Reimbursements"));
  }, []);

  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const userFromStorage = JSON.parse(localStorage.getItem("user")) || {};
  const [userLogin, setUserLogin] = useState(
    userFromStorage?.DefaultContactID || ""
  );
  
  const initialFilterdata = [
    { label: "Employee", value: userLogin },
    { label: "Status", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ];
  const [expenseData, setExpenseData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [empList, setEmplist] = useState([]);
  const [Status, setStatus] = useState([]);
  const [filterFormData, setFilterData] = useState(initialFilterdata);  
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    Name: { text: "Employee", visible: true },
    ProjectName: { text: "Project", visible: true },
    SuperiorName: { text: "Manager", visible: true },
    FromDate: { text: "From", align: "end", visible: true },
    ToDate: { text: "To", align: "end", visible: true },
    AdvanceAmountBASE: {
      text: "Advance Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    TXNNAME: { text: "Receipt No.", visible: true },
    TotalExpense: {
      text: "Total Expense (\u20B9)",
      align: "end",
      visible: true,
    },
    ApprovedAmountBASE: {
      text: "Approved Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    BalanceAmountBASE: {
      text: "Balance Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    Status: { text: "Status", visible: true },
    ActionByName: { text: "Action By", visible: true },
    PayrollMonth: { text: "Payroll Month",align:"center", visible: true },
  };

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleFilterReset = () => {
    // Reset to empty/default values without passing any specific data
    setFilterData(initialFilterdata);
    // Call API with empty/default parameters
    fetchMyReimbursement();
  };
  const fetchMyReimbursement = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/my-reimbursements?P_EmployeeID=${userLogin}&P_FromDate=${lastMonthDate}&P_ToDate=${todayDate}&P_Status=${0}`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const ExpenseData = response?.data?.data?.header;
        setExpenseData(ExpenseData);
        // Employee list
        const empList = response?.data?.data?.employeeList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmplist(empList);

        // status list
        const statusList = response?.data?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(statusList);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  const handleGetData = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/my-reimbursements?P_EmployeeID=${
          filterFormData.find((o) => o.label === "Employee")
            ? filterFormData.find((o) => o.label === "Employee").value
            : 0
        }&P_FromDate=${
          filterFormData.find((o) => o.label === "From Date")
            ? moment(
                filterFormData.find((o) => o.label === "From Date").value
              ).format("YYYY-MM-DD")
            : lastMonthDate
        }&P_ToDate=${
          filterFormData.find((o) => o.label === "To Date")
            ? moment(
                filterFormData.find((o) => o.label === "To Date").value
              ).format("YYYY-MM-DD")
            : todayDate
        }&P_Status=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : 0
        }`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const ExpenseData = response?.data?.data?.header;
        setExpenseData(ExpenseData);
        // Employee list
        const empList = response?.data?.data?.employeeList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmplist(empList);

        // status list
        const statusList = response?.data?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(statusList);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  useEffect(() => {
    fetchMyReimbursement();
  }, []);

  const formDatas = [
    { name: "Employee", type: "Select", options: [...empList] },
    { name: "Status", type: "Select", options: [...Status] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];

  const handleViewTnE = (id) => {
    navigate(`/new-tne/view/${id.ID}`, { state: { from: location.pathname } });
  };

  const handleEdit = (id) => {
    navigate(`/new-tne/edit/${id.ID}`);
  };

  const handleTnE = (id) => {
    navigate(`/my-reimbursements/report/exportTne/${id.ID}`);
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <ReimburseComponent
              data={expenseData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon1={true}
              showIcon2={true}
              showIcon3={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              formDatas={formDatas}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              handleGetData={handleGetData}
              handleChange={handleChange}
              filterFormData={filterFormData}
              isActionRequired={true}
              handleIcon1={handleViewTnE}
              handleIcon2={handleEdit}
              handleIcon3={handleTnE}
              handleReset={handleFilterReset}
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View",
                Icon2: <i className="fa fa-edit"></i>,
                Icon2Text: "Edit",
                Icon2Flag: "canEdit",
                Icon3: <i className="bi bi-download"></i>,
                Icon3Text: "Export TnE",
                Icon3Flag: "ApplicationStatus_123",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MyReimbursements;
